import { ofetch } from "ofetch";
export class StreamChatTokenProvider {
  initialToken;
  config;
  constructor(token, config) {
    this.initialToken = token;
    this.config = config;
  }
  /**
   * Refresh token by calling the backend refresh endpoint
   */
  async refreshToken() {
    if (!this.config) {
      throw new Error("No configuration provided");
    }
    try {
      const refreshUrl = new URL(
        `/api/v4/cms/public/chat/sessions/${this.config.sessionId}/refresh`,
        this.config.endpoint
      ).toString();
      const params = {
        session_id: this.config.sessionId,
        secondary_organization_id: Number(this.config.secondaryOrgId)
      };
      const response = await ofetch(refreshUrl, {
        method: "POST",
        body: params
      });
      if (!response || !response.success) {
        throw new Error("Token refresh failed - no valid response");
      }
      return response.data.user_token;
    } catch (error) {
      const errorMessage = error instanceof Error ? error.message : "Unknown error";
      throw new Error(`Token refresh failed: ${errorMessage}`);
    }
  }
  /**
   * Create a Stream Chat compatible token provider function
   * This function will be called by Stream Chat when tokens need to be refreshed
   */
  createTokenProvider() {
    return async () => {
      try {
        const initialToken = this.initialToken;
        if (initialToken) {
          this.initialToken = "";
          return initialToken;
        }
        const refreshedToken = await this.refreshToken();
        console.log("\u2705 Token refreshed successfully for Stream Chat");
        return refreshedToken;
      } catch (error) {
        console.error("\u274C Token refresh failed for Stream Chat:", error);
        throw error;
      }
    };
  }
}
